import { Link } from "react-router-dom";
import { PosChange } from "@/components/common";

const medal = (p) => (p === 1 ? "text-[#d6b3ff]" : p === 2 ? "text-[#F5F5F7]" : p === 3 ? "text-[#C6C6CE]" : "text-[#C6C6CE]/60");

function NameCell({ row }) {
  return (
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        {row.tag && <span className="font-num text-[10px] px-1.5 py-0.5 border border-[#C6C6CE]/20 rounded text-[#C6C6CE]">{row.tag}</span>}
        {row.clan_slug ? (
          <Link to={`/clan/${row.clan_slug}`} className="font-semibold text-[#F5F5F7] hover:text-[#962FFF] truncate transition-colors duration-200">{row.name}</Link>
        ) : <span className="font-semibold text-[#F5F5F7] truncate">{row.name}</span>}
      </div>
      {row.players?.length > 0 && <div className="text-[11px] text-[#C6C6CE]/50 truncate mt-0.5">{row.players.join(" · ")}</div>}
    </div>
  );
}

export function StandingsTable({ rows, extraStats = [], showChange = true, showPrize = false, compact = false }) {
  return (
    <div data-testid="standings-table">
      <div className="hidden md:block nx-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-[#0B0B0F]/95 backdrop-blur-xl">
            <tr className="text-[10px] uppercase tracking-[0.18em] text-[#C6C6CE]/60 font-display border-b border-[#C6C6CE]/10">
              <th className="text-left py-3 pl-5 w-14">Pos</th>
              {showChange && <th className="text-left py-3 w-12">Var</th>}
              <th className="text-left py-3">Partecipante</th>
              <th className="text-right py-3 px-3">Punti</th>
              {!compact && <th className="text-right py-3 px-3">Vitt.</th>}
              {!compact && <th className="text-right py-3 px-3">Elim.</th>}
              {!compact && <th className="text-right py-3 px-3">Match</th>}
              {!compact && extraStats.map((s) => <th key={s.key} className="text-right py-3 px-3">{s.label}</th>)}
              {showPrize && <th className="text-right py-3 pr-5">Premio</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.registration_id} data-testid={`standings-row-${r.position}`} className="border-b border-[#C6C6CE]/5 hover:bg-[#17171D] transition-colors duration-200 fade-up" style={{ animationDelay: `${Math.min(i, 12) * 30}ms` }}>
                <td className={`py-3.5 pl-5 font-num font-bold text-lg ${medal(r.position)}`}>{String(r.position).padStart(2, "0")}</td>
                {showChange && <td className="py-3.5"><PosChange value={r.change} /></td>}
                <td className="py-3.5 pr-3 max-w-[320px]"><NameCell row={r} /></td>
                <td className="py-3.5 px-3 text-right font-num font-bold text-[#F5F5F7] text-base">{r.points}</td>
                {!compact && <td className="py-3.5 px-3 text-right font-num text-[#C6C6CE]">{r.wins}</td>}
                {!compact && <td className="py-3.5 px-3 text-right font-num text-[#C6C6CE]">{r.kills}</td>}
                {!compact && <td className="py-3.5 px-3 text-right font-num text-[#C6C6CE]/70">{r.matches}</td>}
                {!compact && extraStats.map((s) => <td key={s.key} className="py-3.5 px-3 text-right font-num text-[#C6C6CE]">{r.extra?.[s.key] ?? 0}</td>)}
                {showPrize && <td className="py-3.5 pr-5 text-right text-xs text-[#d6b3ff]">{r.prize || "—"}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="md:hidden space-y-2.5">
        {rows.map((r) => (
          <div key={r.registration_id} data-testid={`standings-card-${r.position}`} className="nx-card p-4 flex items-center gap-4">
            <div className={`font-num font-bold text-2xl w-10 ${medal(r.position)}`}>{r.position}</div>
            <div className="flex-1 min-w-0">
              <NameCell row={r} />
              <div className="flex gap-3 mt-2 text-[11px] text-[#C6C6CE]/60 font-num">
                <span>V {r.wins}</span><span>E {r.kills}</span><span>M {r.matches}</span>
                {showChange && <PosChange value={r.change} />}
              </div>
              {showPrize && r.prize && <div className="text-[11px] text-[#d6b3ff] mt-1">{r.prize}</div>}
            </div>
            <div className="text-right">
              <div className="font-num font-bold text-xl text-[#F5F5F7]">{r.points}</div>
              <div className="text-[9px] uppercase tracking-widest text-[#C6C6CE]/50">punti</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
